// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Montserrat', sans-serif !important;
  box-sizing: border-box;
}

.md-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

/* темная тема (по умолчанию) */
body.h-theme-dark .md-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

/* светлая тема */
body.h-theme-light .md-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: relative;
}

.md-content {
  position: relative;
  z-index: 1;
  padding: 20px;
  width: 100%;
  max-width: 1400px;
  margin: auto;
}

.md-white-background {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 1900px;
  margin: 20px auto;
  min-height: 400px;
}

.md-main {
  padding: 30px;
}

.md-content-area {
  width: 100%;
}

.md-section-title {
  margin: 0;
  color: #002FA7;
}

.md-section-subtitle {
  margin-top: 5px;
  margin-bottom: 40px;
  color: #002FA7;
}

.md-button-icon-container {
  width: 55px;
  height: 55px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);
  transition: all 0.3s ease;
}

.md-button-icon {
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;
}

/* кнопки */
.md-buttons-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
  padding: 10px 0;
}

/* Строка с кнопками */
.md-buttons-row {
  display: flex;
  gap: 20px;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}

/* Кнопка */
.md-button {
  width: 100%;
  height: 200px;
  background: white;
  border: 2px solid rgba(0, 47, 167, 0.1);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.md-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 47, 167, 0.15);
  border-color: rgba(0, 47, 167, 0.3);
}

.md-button:hover .md-button-icon {
  transform: scale(1.1);
}

.md-button-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
  line-height: 1.3;
}

.md-button-desc {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #002FA7;
  line-height: 1.4;
  text-align: left;
}

/* анимированный фон */
.md-background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.md-shape {
  position: absolute;
  opacity: 0.1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: md-float 20s infinite linear;
}

.md-shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }
.md-shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }
.md-shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }

@keyframes md-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(90deg); }
  50% { transform: translateY(0) rotate(180deg); }
  75% { transform: translateY(20px) rotate(270deg); }
}`, "",{"version":3,"sources":["webpack://./src/pages/MetodistStyle.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,cAAc,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE;AAChE,cAAc,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,UAAU,EAAE,oBAAoB,EAAE;AACvF,cAAc,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAE1F;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,0CAA0C,EAAE;EAClD,MAAM,uCAAuC,EAAE;EAC/C,MAAM,0CAA0C,EAAE;AACpD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n  box-sizing: border-box;\n}\n\n.md-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n/* темная тема (по умолчанию) */\nbody.h-theme-dark .md-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n/* светлая тема */\nbody.h-theme-light .md-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: relative;\n}\n\n.md-content {\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  width: 100%;\n  max-width: 1400px;\n  margin: auto;\n}\n\n.md-white-background {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 1900px;\n  margin: 20px auto;\n  min-height: 400px;\n}\n\n.md-main {\n  padding: 30px;\n}\n\n.md-content-area {\n  width: 100%;\n}\n\n.md-section-title {\n  margin: 0;\n  color: #002FA7;\n}\n\n.md-section-subtitle {\n  margin-top: 5px;\n  margin-bottom: 40px;\n  color: #002FA7;\n}\n\n.md-button-icon-container {\n  width: 55px;\n  height: 55px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);\n  transition: all 0.3s ease;\n}\n\n.md-button-icon {\n  width: 30px;\n  height: 30px;\n  filter: brightness(0) invert(1);\n  transition: all 0.3s ease;\n}\n\n/* кнопки */\n.md-buttons-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  width: 100%;\n  padding: 10px 0;\n}\n\n/* Строка с кнопками */\n.md-buttons-row {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* Кнопка */\n.md-button {\n  width: 100%;\n  height: 200px;\n  background: white;\n  border: 2px solid rgba(0, 47, 167, 0.1);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.md-button:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 40px rgba(0, 47, 167, 0.15);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.md-button:hover .md-button-icon {\n  transform: scale(1.1);\n}\n\n.md-button-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n  line-height: 1.3;\n}\n\n.md-button-desc {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: #002FA7;\n  line-height: 1.4;\n  text-align: left;\n}\n\n/* анимированный фон */\n.md-background-animation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.md-shape {\n  position: absolute;\n  opacity: 0.1;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  animation: md-float 20s infinite linear;\n}\n\n.md-shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }\n.md-shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }\n.md-shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }\n\n@keyframes md-float {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  25% { transform: translateY(-20px) rotate(90deg); }\n  50% { transform: translateY(0) rotate(180deg); }\n  75% { transform: translateY(20px) rotate(270deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
